import { useEffect, useState, useRef, Fragment } from "react"
import { useInView } from 'react-hook-inview'
import { useNavigate } from "react-router-dom"
import { HomepageReactGAHandlers } from "../ReactGAHandlers"

export const ExplorerBlock = ({ backgroundImage, title, contentArray, link, mobileContentArray, backgroundPosition, GAHandlerGroup }) => {

  const { handleHomepageClick } = HomepageReactGAHandlers()

  let navigate = useNavigate()
  const [pointController, setPointController] = useState({
    activePoint: 0,
    timerActive: false,
    clicked: false,
    timer: 0
  })
  const [progressBarRef, isVisible] = useInView({ threshold: 0.5 })

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    if (isVisible && pointController.timerActive == false) {
      setPointController(prevState => ({
        ...prevState, timerActive: true
      }));
    }

    if (!isVisible && pointController.timerActive == true) {
      setPointController(prevState => ({
        ...prevState, timer: 0, timerActive: false
      }));
    }
  }, [isVisible])

  useEffect(() => {

    if (pointController.clicked) {
      setPointController(prevState => ({
        ...prevState,
        timer: 100,
        timerActive: false,
      }));
      return;
    }

    if (pointController.timer >= 100) {
      const max = contentArray.length;

      setPointController(prevState => ({
        ...prevState,
        activePoint: prevState.activePoint + 1 >= max ? 0 : prevState.activePoint + 1,
        timer: 0
      }));
    }
  }, [pointController.timer, pointController.clicked]);

  useEffect(() => {
    if (!pointController.clicked && pointController.timer < 100 && pointController.timerActive) {
      const interval = setInterval(() => {
        setPointController(prevState => {
          if (prevState.timer >= 100) {
            clearInterval(interval);
            return { ...prevState, timer: 100 };
          }
          return { ...prevState, timer: prevState.timer + 1.5 };
        });
      }, 100);

      return () => clearInterval(interval);
    }
  }, [pointController.activePoint, pointController.timerActive]);

  const progressBar = (point) => {

    const returnProgressBarValue = (point) => {
      if (pointController.activePoint == point && pointController.clicked == false && pointController.timerActive) {
        return `${pointController?.timer}%`
      }

      if (pointController.activePoint == point && pointController.clicked == true) {
        return `100%`
      }

      else {
        return `0%`
      }
    }

    return <div
      className="dca-home-explorer-progressbar progress"
      style={{
        backgroundColor: pointController.activePoint == point ? '#F8F8F8' : 'transparent'
      }}>
      <div
        className="progress-bar"
        role="progressbar"
        style={{
          height: returnProgressBarValue(pointController.activePoint),
          width: '100%',
          backgroundColor: pointController.activePoint == point ? '#DAF8B9' : 'transparent',
          transition: 'height 0.1s ease-in',
        }}
        aria-valuenow={pointController.timer}
        aria-valuemin={0}
        aria-valuemax={100}
      >
      </div>
    </div>
  }

  const titleElement = <span className="dca-home-explorer-title">{title}</span>

  const navigateLink = <span className="dca-home-explorer-block-link-wrapper" onClick={() => {
    handleHomepageClick(`${GAHandlerGroup} Block Peek Link`);
    navigate(link.navigate)
  }}>
    <img className={`dca-home-explorer-block-link-icon ${link.className}`} src={link.icon} alt={`${link.text}_icon`}></img>
    <span className="dca-home-explorer-block-link">{link.text}</span>
    <i
      className="ms-2 fa-solid fa-arrow-right dca-home-explorer-arrow"
    ></i>
  </span>

  const takeAPeek = <span className="dca-home-explorer-take-a-peek-text">TAKE A PEEK</span>

  const content = <div
    className="dca-home-explorer-content">
    {contentArray.map((res, index) => (
      <div
        key={res.activePoint}
        className="d-flex flex-row"
        style={{ paddingBottom: index < contentArray.length - 1 ? '50px' : '' }}>
        {progressBar(res.activePoint)}

        <div className="d-flex flex-column">
          <span
            onClick={() => {
              handleHomepageClick(`${GAHandlerGroup} Block Point ${index + 1}`);
              setPointController(prevState => ({
                ...prevState,
                activePoint: res.activePoint,
                clicked: true,
                timer: 0
              }))
            }}
            className={pointController.activePoint == res.activePoint ? 'dca-home-explorer-span-text fw-bold' : 'dca-home-explorer-span-text'}
            style={{ cursor: 'pointer' }}>{res.span1}</span>

          {pointController.activePoint == res.activePoint && res.activeSpan && <span style={{ color: '#5f6368', paddingTop: '15px' }}>{res.activeSpan}</span>}
        </div>

      </div>
    ))}

    {takeAPeek}
    {navigateLink}
  </div>

  const midMobileContent = <div
    className="dca-home-explorer-content">
    {contentArray.map((res, index) => (
      <Fragment key={res.activePoint}>
        <div
          className="d-flex flex-row"
          style={{ paddingBottom: '50px' }}>
          {progressBar(res.activePoint)}

          <div className="d-flex flex-column">
            <span
              onClick={() => {
                handleHomepageClick(`${GAHandlerGroup} Block Point ${index + 1}`);
                setPointController(prevState => ({
                  ...prevState,
                  activePoint: res.activePoint,
                  clicked: true,
                  timer: 0
                }))
              }}
              className={pointController.activePoint == res.activePoint ? 'dca-home-explorer-span-text fw-bold' : 'dca-home-explorer-span-text'}
              style={{ cursor: 'pointer' }}>{res.span1}</span>

            {pointController.activePoint == res.activePoint && res.activeSpan && <span style={{ color: '#5f6368', paddingTop: '15px' }}>{res.activeSpan}</span>}
          </div>


        </div>

        {pointController.activePoint === res.activePoint && <div className={`dca-explorer-block-content-image-mobile`}>
          <img
            src={res.image}
            id={`dca-explorer-block-content-image-${res.group}${res.activePoint} ${res.customImage ? `dca-explorer-block-content-image-custom-${res.customImage}` : ''}`}
            className={pointController.activePoint === res.activePoint ? "active" : "hidden"}
          />
        </div>}
      </Fragment>
    ))}

    {takeAPeek}

    {navigateLink}
  </div>

  const mobileContent = <div
    className="dca-home-explorer-content">
    {mobileContentArray.map((res, index) => (
      <Fragment key={res.activePoint}>
        <div
          className="d-flex flex-row"
          style={{ paddingBottom: '30px' }}>
          {progressBar(res.activePoint)}

          <div className="d-flex flex-column">
            <span
              onClick={() => {
                handleHomepageClick(`${GAHandlerGroup} Block Point ${index + 1}`);
                setPointController(prevState => ({
                  ...prevState,
                  activePoint: res.activePoint,
                  clicked: true,
                  timer: 0
                }))
              }}
              className={pointController.activePoint == res.activePoint ? 'dca-home-explorer-span-text fw-bold' : 'dca-home-explorer-span-text'}
              style={{ cursor: 'pointer' }}>{res.span1}</span>

            {pointController.activePoint == res.activePoint && res.activeSpan && <span style={{ color: '#5f6368', paddingTop: '15px' }}>{res.activeSpan}</span>}
          </div>


        </div>

        {pointController.activePoint === res.activePoint && <div className={`dca-explorer-block-content-image-mobile`}>
          <img
            src={res.image}
            id={`dca-explorer-block-content-image-${res.group}${res.activePoint} ${res.customImage ? `dca-explorer-block-content-image-custom-${res.customImage}` : ''}`}
            className={pointController.activePoint === res.activePoint ? "active" : "hidden"}
          />
        </div>}
      </Fragment>
    ))}

    {takeAPeek}

    {navigateLink}
  </div>

  const contentImage = (
    <div className="dca-explorer-block-content-image">
      {contentArray.map((res) => (
        <img
          key={res.activePoint}
          src={res.image}
          id={`dca-explorer-block-content-image-${res.group}${res.activePoint} ${res.customImage ? `dca-explorer-block-content-image-custom-${res.customImage}` : ''}`}
          className={pointController.activePoint === res.activePoint ? "active" : "hidden"}
        />
      ))}
    </div>
  );

  const contentContainer = <div className="dca-home-explorer-content-container d-flex flex-column">
    <div className="d-flex flex-row">
      {content}
      {contentImage}
    </div>
  </div>

  const midMobileContentContainer = <div className="dca-home-explorer-content-container">
    {midMobileContent}
  </div>

  const mobileContentContainer = <div className="dca-home-explorer-content-container">
    {mobileContent}
  </div>

  return <div
    className="dca-home-explorer-block-container">
    <div
      ref={progressBarRef}
      className="dca-home-explorer-block-container-image"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundPosition: backgroundPosition ? backgroundPosition : ''
      }}>
      {titleElement}

      {windowWidth > 1150 ? <div className='d-flex' style={{ width: '100%' }}>
        {contentContainer}
      </div> : windowWidth > 768 ? <div className='d-flex' style={{ width: '100%' }}>
        {midMobileContentContainer}
      </div> : <div className='d-flex' style={{ width: '100%' }}>
        {mobileContentContainer}
      </div>}

    </div>
  </div>
}